import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { useState, useEffect } from 'react';
import { Snackbar } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

const useStyles = makeStyles(() => ({
  root: {
    maxWidth: '800px',
    marginBottom: '50px'
  }
}));

export default function UserMessageSnackbar(props) {
  const { openSnackbar, message, severity, onClose } = props;
  const [open, setOpen] = useState(false);
  const classes = useStyles();

  useEffect(() => {
    setOpen(false);
  }, []);

  useEffect(() => {
    openSnackbar && setOpen(true);
  }, [openSnackbar, severity, message]);

  const handleClose = reason => {
    if (reason === 'clickaway') {
      return;
    }
    if (typeof onClose === 'function') {
      onClose();
    } else {
      setOpen(false);
    }
  };

  return (
    <Snackbar
      className={classes.root}
      open={open && openSnackbar}
      autoHideDuration={6000}
      onClose={handleClose}>
      <Alert onClose={handleClose} severity={severity}>
        {message}
      </Alert>
    </Snackbar>
  );
}
